import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import api from '../utils/api';

const QUESTIONS = [
  {
    id: 1,
    text: 'Ki számára keresed a kerékpárt?',
    answers: [
      { label: 'Magamnak (felnőtt)',       emoji: '🧑', scores: { elektromos: 1, tura: 1, varosi: 1, gyermek: 0 } },
      { label: 'Gyereknek (12 év alatt)',  emoji: '👧', scores: { elektromos: 0, tura: 0, varosi: 0, gyermek: 12 } },
      { label: 'Gyereknek (12 év felett)', emoji: '👨‍👩‍👧', scores: { elektromos: 0, tura: 2, varosi: 2, gyermek: 0 } },
    ],
  },
  {
    id: 2,
    text: 'Mire használnád főként?',
    answers: [
      { label: 'Munkába járásra, városban',      emoji: '🏙️', scores: { elektromos: 2, tura: 0, varosi: 3, gyermek: 0 } },
      { label: 'Túrázásra, kirándulásra',        emoji: '🌲', scores: { elektromos: 0, tura: 4, varosi: 0, gyermek: 0 } },
      { label: 'Kényelmes, erőfeszítés nélkül', emoji: '⚡', scores: { elektromos: 4, tura: 0, varosi: 0, gyermek: 0 } },
      { label: 'Mindennapi vegyes használat',    emoji: '🎯', scores: { elektromos: 1, tura: 1, varosi: 2, gyermek: 0 } },
    ],
  },
  {
    id: 3,
    text: 'Milyen terepen tekersz?',
    answers: [
      { label: 'Csak aszfalton, városban',      emoji: '🛣️', scores: { elektromos: 2, tura: 0, varosi: 3, gyermek: 0 } },
      { label: 'Erdőn, dombos terepen',         emoji: '🌄', scores: { elektromos: 0, tura: 4, varosi: 0, gyermek: 0 } },
      { label: 'Vegyes (aszfalt + kirándulás)', emoji: '🔀', scores: { elektromos: 1, tura: 2, varosi: 1, gyermek: 0 } },
    ],
  },
  {
    id: 4,
    text: 'Milyen messzire tekersz átlagosan?',
    answers: [
      { label: 'Rövid (0–10 km/nap)',    emoji: '🏠', scores: { elektromos: 0, tura: 0, varosi: 3, gyermek: 1 } },
      { label: 'Közepes (10–30 km/nap)', emoji: '🚦', scores: { elektromos: 3, tura: 0, varosi: 2, gyermek: 0 } },
      { label: 'Hosszú (30+ km/nap)',    emoji: '🗺️', scores: { elektromos: 2, tura: 3, varosi: 0, gyermek: 0 } },
    ],
  },
  {
    id: 5,
    text: 'Mi a legfontosabb számodra?',
    answers: [
      { label: 'Könnyű kezelés, kényelem',  emoji: '💨', scores: { elektromos: 3, tura: 0, varosi: 1, gyermek: 0 } },
      { label: 'Kaland és teljesítmény',    emoji: '🏔️', scores: { elektromos: 0, tura: 4, varosi: 0, gyermek: 0 } },
      { label: 'Ökológia, fenntarthatóság', emoji: '💚', scores: { elektromos: 3, tura: 0, varosi: 0, gyermek: 0 } },
      { label: 'Legjobb ár-érték',          emoji: '💰', scores: { elektromos: 0, tura: 1, varosi: 3, gyermek: 0 } },
    ],
  },
];

const RESULTS = {
  elektromos: {
    label: 'Elektromos kerékpár',
    emoji: '⚡',
    desc: 'Modern és kényelmes — az elektromos meghajtás ideális választás számodra. Élvezd a tekerést erőfeszítés nélkül!',
  },
  tura: {
    label: 'Túrakerékpár',
    emoji: '🌲',
    desc: 'A kaland vár! Megbízható túrakerékpárok minden terepen — akár hosszú kirándulásokra, akár vegyes útra.',
  },
  varosi: {
    label: 'Városi kerékpár',
    emoji: '🏙️',
    desc: 'Stílusos és praktikus — tökéletes a mindennapi használathoz. Egyszerű, megbízható, tökéletes városban.',
  },
  gyermek: {
    label: 'Gyermekkerékpár',
    emoji: '🌟',
    desc: 'Biztonságos és vidám kerékpárok a kis tekercselőknek — 12"-tól 24"-ig minden korosztálynak.',
  },
};

function calcResult(scores) {
  return Object.entries(scores).reduce(
    (best, [cat, score]) => (score > scores[best] ? cat : best),
    'varosi'
  );
}

export default function Quiz() {
  const [step, setStep]         = useState(0);
  const [scores, setScores]     = useState({ elektromos: 0, tura: 0, varosi: 0, gyermek: 0 });
  const [result, setResult]     = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading]   = useState(false);

  const question = QUESTIONS[step];
  const progress = step < 5 ? (step / QUESTIONS.length) * 100 : 100;

  const handleAnswer = (answer) => {
    const newScores = { ...scores };
    Object.entries(answer.scores).forEach(([cat, pts]) => {
      newScores[cat] += pts;
    });
    setScores(newScores);

    if (step < QUESTIONS.length - 1) {
      setStep(step + 1);
    } else {
      const winner = calcResult(newScores);
      setResult(winner);
      setLoading(true);
      setStep(5);
      api(`/api/products?category=${winner}&limit=8`)
        .then(r => r.json())
        .then(d => { setProducts(d.products || []); setLoading(false); })
        .catch(() => setLoading(false));
    }
  };

  const restart = () => {
    setStep(0);
    setScores({ elektromos: 0, tura: 0, varosi: 0, gyermek: 0 });
    setResult(null);
    setProducts([]);
  };

  return (
    <main style={{ background: '#08080f', minHeight: '100vh', paddingTop: 'var(--nav-height)' }}>
      <div className="container" style={{
        padding: 'var(--sp-10) var(--container-pad) var(--sp-16)',
        maxWidth: 720,
        margin: '0 auto',
      }}>

        {step < 5 ? (
          <>
            {/* Progress */}
            <div className="quiz-progress">
              <div className="quiz-progress__fill" style={{ width: `${progress}%` }} />
            </div>
            <p style={{ fontSize: 'var(--fs-xs)', color: 'rgba(255,255,255,0.4)', marginBottom: 'var(--sp-8)', textAlign: 'center', letterSpacing: '0.10em' }}>
              {step + 1} / {QUESTIONS.length}
            </p>

            {/* Question */}
            <h2 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(1.4rem, 4vw, 2.2rem)',
              fontWeight: 700,
              color: 'white',
              textAlign: 'center',
              marginBottom: 'var(--sp-10)',
              lineHeight: 1.2,
            }}>
              {question.text}
            </h2>

            {/* Answers */}
            <div className="quiz-answers">
              {question.answers.map((answer, i) => (
                <button key={i} className="quiz-answer" onClick={() => handleAnswer(answer)} aria-label={answer.label}>
                  <span className="quiz-answer__emoji" aria-hidden="true">{answer.emoji}</span>
                  <span className="quiz-answer__label">{answer.label}</span>
                </button>
              ))}
            </div>

            {/* Back */}
            {step > 0 && (
              <div style={{ textAlign: 'center', marginTop: 'var(--sp-8)' }}>
                <button
                  onClick={() => setStep(step - 1)}
                  style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.35)', cursor: 'pointer', fontSize: 'var(--fs-sm)' }}
                >
                  ← Vissza
                </button>
              </div>
            )}
          </>
        ) : result ? (
          <>
            {/* Result */}
            <div style={{ textAlign: 'center', marginBottom: 'var(--sp-10)' }}>
              <div style={{ fontSize: 64, marginBottom: 'var(--sp-4)', lineHeight: 1 }}>
                {RESULTS[result].emoji}
              </div>
              <p style={{ fontSize: 'var(--fs-xs)', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--coral)', marginBottom: 'var(--sp-3)' }}>
                Neked illik a legjobban
              </p>
              <h2 style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                fontWeight: 900,
                color: 'white',
                letterSpacing: '-0.02em',
                marginBottom: 'var(--sp-4)',
              }}>
                {RESULTS[result].label}
              </h2>
              <p style={{ fontSize: 'var(--fs-md)', color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, maxWidth: 480, margin: '0 auto' }}>
                {RESULTS[result].desc}
              </p>
            </div>

            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--sp-12)' }}>
                <span className="spinner" style={{ width: 40, height: 40, borderWidth: 3 }} />
              </div>
            ) : products.length > 0 && (
              <div style={{ marginBottom: 'var(--sp-10)' }}>
                <p style={{ fontSize: 'var(--fs-xs)', color: 'rgba(255,255,255,0.4)', textAlign: 'center', marginBottom: 'var(--sp-6)', letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 600 }}>
                  Ajánlott kerékpárok
                </p>
                <div style={{
                  display: 'flex',
                  gap: 'var(--sp-4)',
                  overflowX: 'auto',
                  scrollbarWidth: 'none',
                  paddingBottom: 'var(--sp-2)',
                  WebkitOverflowScrolling: 'touch',
                }}>
                  {products.map(p => (
                    <div key={p.id} style={{ flexShrink: 0, width: 'clamp(200px, 40vw, 260px)' }}>
                      <ProductCard product={p} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--sp-3)' }}>
              <Link
                to={`/kerekparok?category=${result}`}
                className="btn btn-primary btn-lg"
                style={{ textDecoration: 'none', minWidth: 280, justifyContent: 'center' }}
              >
                Összes {RESULTS[result].label} →
              </Link>
              <button
                onClick={restart}
                style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.35)', cursor: 'pointer', fontSize: 'var(--fs-sm)', padding: 'var(--sp-2)' }}
              >
                ← Újrakezdem
              </button>
            </div>
          </>
        ) : null}
      </div>
    </main>
  );
}
